import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-updates',
  templateUrl: './content-updates.component.html',
  styleUrls: ['./content-updates.component.scss']
})
export class ContentUpdatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
